import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from 'app/layout/layout.component';
import {EmptyLayoutModule} from 'app/layout/layouts/empty/empty.module';
import {CenteredLayoutModule} from './layouts/horizontal/centered/centered.module';
import {FuturisticLayoutModule} from './layouts/vertical/futuristic/futuristic.module';

const modules = [
    // Empty
    EmptyLayoutModule,
    // Horizontal navigation
    CenteredLayoutModule,

    // Vertical navigation
    FuturisticLayoutModule
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports: [
        CommonModule,
        ...modules
    ],
    exports: [
        ...modules
    ]
})
export class LayoutModule {
}
